// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../index';

import { gql } from 'graphql-tag';
import { StoneShapeFragmentDoc } from './stoneShape.fragment.generated';
import { MoneyFragmentDoc } from '../../../fragments/money.fragment.generated';
import { StoneCutFragmentDoc } from './stoneCut.fragment.generated';
import { StoneCrystalFragmentDoc } from './stoneCrystal.fragment.generated';
import { StoneColorFragmentDoc } from '../../gems/fragments/StoneColor.fragment.generated';
import { StoneGradeFragmentDoc } from './stoneGrade.fragment.generated';
import { StoneClarityFragmentDoc } from '../../gems/fragments/stoneClarity.fragment.generated';
import { NonSkuGemstoneImageFragmentDoc } from '../../../../../domain/stone/useStoneImage.generated';
export const NonSkuGemstoneFragmentDoc = gql`
    fragment nonSkuGemstone on NonSkuGemstone {
  __typename
  id
  shape {
    ...stoneShape
  }
  salePrice(currency: $currency, country: $country) {
    ...money
  }
  cut {
    ...stoneCut
  }
  caratWeight
  crystal {
    ...stoneCrystal
  }
  color {
    ...stoneColor
  }
  colorGrade {
    ...stoneGrade
  }
  clarity {
    ...stoneClarity
  }
  ...nonSkuGemstoneImage
}
    ${StoneShapeFragmentDoc}
${MoneyFragmentDoc}
${StoneCutFragmentDoc}
${StoneCrystalFragmentDoc}
${StoneColorFragmentDoc}
${StoneGradeFragmentDoc}
${StoneClarityFragmentDoc}
${NonSkuGemstoneImageFragmentDoc}`;